(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.utility-bar');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar ? this.announcementBar.offsetHeight : 0}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerIsAlwaysSticky) {
        if (document.body.style.position === 'fixed' || document.body.classList.contains('ux-navigation-open')) return;

        // Keep the mobile sticky header at a fixed height.
        // Compacting it while scrolling changes the logo/header dimensions and causes layout jumps on iOS.
        if (window.innerWidth < 990) {
          this.header.classList.remove('ux-header-compact');
        } else if (scrollTop > 160) {
          this.header.classList.add('ux-header-compact');
        } else if (scrollTop < 32) {
          this.header.classList.remove('ux-header-compact');
        }

        this.currentScrollTop = scrollTop;
        return;
      }


      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('ux-product-reviews')) {
  customElements.define('ux-product-reviews', class extends HTMLElement {
    connectedCallback() {
      const parent = this.closest('product-info');
      const slot = this.querySelector('.ux-product-reviews__badge');
      if (!parent || !slot) return;
      const placeReviews = () => {
        const widget = parent.querySelector('.trustpilot-widget[data-template-id="5419b732fbfb950b10de65e5"]');
        if (!widget) return;
        this.observer?.disconnect();
        if (slot.contains(widget)) return;
        const wrapper = widget.closest('[id$="-wrapper"]') || widget;
        slot.appendChild(wrapper);
      };
      this.observer = new MutationObserver(placeReviews);
      this.observer.observe(parent, { childList: true, subtree: true });
      placeReviews();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ux-vat-provider"]) return;
  try {
    
(() => {
  const home = document.getElementById('ux-vat-home');
  const panel = document.getElementById('ux-vat-fields');
  if (!home || !panel || !document.getElementById('main-cart-footer')) return;
  const message = panel.querySelector('[data-vat-message]');
  const country = panel.dataset.country;
  const eligible = 'AT BE BG CY CZ DE DK EE ES FI GR HR HU IE IT LT LU LV MT NL PL PT RO SE SI SK'.split(' ').includes(country);
  let selected = false, pending = null, authorized = false, touched = false, appTouched = false, cleanupNeeded = panel.dataset.existingVat === 'true';
  let valid = false, validatedId = '', validatedEmail = '', totalText = '', timer, scheduled = false;
  const vat = () => panel.querySelector('#VatId');
  const email = () => panel.querySelector('#exemptify_email');
  const normalize = value => {
    let id = value.replace(/[\s.]/g,'').toUpperCase();
    if (id.startsWith('GR')) id = 'EL' + id.slice(2);
    if (id && !/^[A-Z]{2}/.test(id)) id = (country === 'GR' ? 'EL' : country) + id;
    return id;
  };
  const controls = () => Array.from(document.querySelectorAll('[data-vat-toggle]'));
  const targetSlot = () => document.querySelector('#main-cart-footer [data-vat-slot]');
  const requested = () => eligible && selected && !!vat()?.value.trim();
  const emit = event => {
    if (window.uxCartEmit) window.uxCartEmit(event,{vat_exempt:valid});
    else {try {(window.dataLayer = window.dataLayer || []).push({event,vat_exempt:valid});if(typeof window.fbq==='function')window.fbq('trackCustom',event,{vat_exempt:valid});}catch(_) {}}
  };
  function state(status,text) {
    message.dataset.state = status; message.textContent = text;
    document.dispatchEvent(new CustomEvent('ux:vat-state',{detail:{exempt:valid,status}}));
  }
  function sync() {
    scheduled = false;
    const slot = targetSlot();
    const destination = selected && slot ? slot : home;
    if (panel.parentElement !== destination) destination.appendChild(panel);
    panel.hidden = !selected;
    document.querySelector('[data-vat-option="page"]').hidden = !eligible && country !== 'FR';
    const hideExpress = requested() || cleanupNeeded || !!pending;
    if (document.body.classList.contains('ux-vat-requested') !== hideExpress) document.body.classList.toggle('ux-vat-requested', hideExpress);
    controls().forEach(c => {c.checked=selected;c.setAttribute('aria-expanded',String(selected));c.disabled=!!pending;});
    panel.querySelector('[data-vat-validate]').disabled = !!pending;
    panel.querySelector('[data-vat-skip]').hidden = !['invalid','unavailable','valid'].includes(message.dataset.state);
    [vat(),email()].filter(Boolean).forEach(input => {
      const labelText = input.id==='VatId' ? panel.dataset.number : panel.dataset.email;
      input.setAttribute('aria-label',labelText);input.placeholder=labelText;
      if (input.id==='exemptify_email') {
        input.type='email';input.autocomplete='email';
        if (!input.dataset.prefilled && panel.dataset.customerEmail) {input.value=panel.dataset.customerEmail;input.dataset.prefilled='true';}
        input.style.display='block';
      } else {input.autocomplete='off';input.spellcheck=false;}
      if(input.id==='VatId' && !panel.querySelector('#ux-vat-prefix-help')) {
        const hint=document.createElement('small');hint.id='ux-vat-prefix-help';hint.className='ux-vat-prefix-help';
        hint.textContent=panel.dataset.prefixHelp.replace('[prefix]',country==='GR'?'EL':country);
        input.after(hint);input.setAttribute('aria-describedby',hint.id);
      }
      const prefixHint=panel.querySelector('#ux-vat-prefix-help');
      if(input.id==='VatId' && prefixHint && input.nextElementSibling!==prefixHint) input.after(prefixHint);
      input.readOnly = !!pending || (input.id==='exemptify_email' && !!panel.dataset.customerEmail);
      if (!input.previousElementSibling?.classList.contains('ux-vat-field-label')) {
        const label=document.createElement('label');label.className='ux-vat-field-label';label.htmlFor=input.id;label.textContent=labelText;input.before(label);
      }
    });
  }
  function schedule() {if (!scheduled) {scheduled=true;requestAnimationFrame(sync);}}
  function finishPending() {clearTimeout(timer);pending=null;sync();}
  function fail(text,field,status='invalid') {
    clearTimeout(timer);pending=null;valid=false;
    state(status,text);emit('vat_exemption_'+status);sync();
    if(field){field.setAttribute('aria-invalid','true');field.focus({preventScroll:true});}
  }
  function proceed(button) {
    if (!button?.form) return;
    // Reattach the validated guest after an earlier checkout or exemption change.
    const action=new URL(button.form.action,window.location.href);
    if(email()?.value && action.origin===window.location.origin && /\/cart$/.test(action.pathname)) {
      action.searchParams.set('checkout[email]',email().value.trim());
      button.form.action=action.href;
    }
    authorized=true;
    try {button.form.requestSubmit(button);} finally {authorized=false;}
  }
  function begin(button,validateOnly=false) {
    if (pending || !button?.form) return;
    const input=vat(),mail=email();
    if (!requested() && !cleanupNeeded) {if (!validateOnly) proceed(button);return;}
    if (requested()) {
      const id=normalize(input.value);input.value=id;
      if (!/^[A-Z]{2}[A-Z0-9]{4,18}$/.test(id)) return fail(panel.dataset.format,input);
      if (!mail?.value.trim() || !mail.checkValidity()) return fail(panel.dataset.emailRequired,mail);
      if (valid && id===validatedId && mail.value===validatedEmail) {if (!validateOnly) proceed(button);return;}
    }
    // Keep the guest email so Exemptify can resolve and revoke its customer exemption.
    if (!requested() && input) input.value='';
    const proxy=document.getElementById('ux-vat-submit-exemptify');
    if (!proxy) return fail(panel.dataset.unavailable,null,'unavailable');
    panel.querySelector('#StatusImg')?.removeAttribute('src');
    const oldError=panel.querySelector('#ErrMsg');if(oldError)oldError.textContent='';
    valid=false;
    pending={button,validateOnly,id:normalize(input?.value||''),email:mail?.value||'',valid:false,clearing:!requested()};
    state('checking',panel.dataset.checking);sync();
    timer=setTimeout(()=>{if(pending)fail(panel.dataset.unavailable,null,'unavailable');},25000);
    appTouched=true;if(!pending.clearing)emit('vat_exemption_started');
    proxy.click();
  }
  document.addEventListener('change',event=>{
    if(!event.target.matches('[data-vat-toggle]'))return;
    touched=true;selected=event.target.checked;
    if(!selected){cleanupNeeded=cleanupNeeded||valid||appTouched;if(vat())vat().value='';valid=false;state('idle','');}
    sync();
  });
  panel.addEventListener('input',event=>{
    event.target.removeAttribute('aria-invalid');
    cleanupNeeded=cleanupNeeded||valid;valid=false;
    // Guest Exemptify customer IDs belong to the email used in its previous request.
    if(event.target.id==='exemptify_email' && !panel.dataset.customerEmail && panel.querySelector('#CustomerId')) panel.querySelector('#CustomerId').value='';
    state('idle','');sync();
  });
  panel.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();event.stopPropagation();begin(document.getElementById('checkout'),true);}});
  panel.querySelector('[data-vat-validate]').addEventListener('click',()=>begin(document.getElementById('checkout'),true));
  panel.querySelector('[data-vat-skip]').addEventListener('click',()=>{
    const needsCleanup=cleanupNeeded || valid;
    if(vat())vat().value='';
    valid=false;selected=true;state('idle',panel.dataset.withTax);sync();
    // Let the app revoke an existing exemption before returning to ordinary checkout.
    if(needsCleanup){cleanupNeeded=true;begin(document.getElementById('checkout'));}
    else {
      const button=document.getElementById('checkout');
      button.form.action=window.routes?.cart_url || '/cart';button.form.method='post';
      selected=false;sync();proceed(button);
    }
  });
  document.addEventListener('click',event=>{
    const button=event.target.closest('button,input[type="submit"]');if(!button)return;
    if(button.id==='ux-vat-submit-exemptify'){if(!pending){event.preventDefault();event.stopImmediatePropagation();}return;}
    if(button.id==='ux-vat-submit'){
      event.preventDefault();event.stopImmediatePropagation();const p=pending;
      if(!p || (!p.clearing && (!p.valid || normalize(vat()?.value||'')!==p.id || (email()?.value||'')!==p.email)))return;
      cleanupNeeded=false;valid=!p.clearing;
      if(p.clearing)selected=false;
      validatedId=p.id;validatedEmail=p.email;
      finishPending();state(valid?'valid':'idle',valid?panel.dataset.valid.replace('[amount]',totalText):panel.dataset.withTax);
      if(valid)emit('vat_exemption_valid');
      if(!p.validateOnly)proceed(p.button);
      return;
    }
    if(button.id!=='checkout' || authorized || (!requested() && !cleanupNeeded))return;
    event.preventDefault();event.stopImmediatePropagation();begin(button);
  },true);
  document.addEventListener('submit',event=>{
    if(authorized || (!requested() && !cleanupNeeded) || event.target.id!=='cart')return;
    event.preventDefault();event.stopImmediatePropagation();begin(event.submitter||document.getElementById('checkout'));
  },true);
  document.body.addEventListener('ExemptifyValidationComplete',event=>{
    if(!pending)return;
    if(event.detail?.validation_successful===true && event.detail?.same_country!=='true' && event.detail?.same_country!==true) pending.valid=true;
    else {
      const unavailable=/ERROR|TIMEOUT/.test(event.detail?.result_message||'');
      fail(unavailable?panel.dataset.unavailable:panel.dataset.invalid,null,unavailable?'unavailable':'invalid');
    }
  });
  document.addEventListener('ExemptifyButtonsReady',()=>{if(vat()?.value)cleanupNeeded=true;sync();});
  document.addEventListener('ux:cart-total',event=>{totalText=event.detail.money;if(valid)message.textContent=panel.dataset.valid.replace('[amount]',totalText);});
  new MutationObserver(()=>{
    if(pending && panel.querySelector('#StatusImg')?.getAttribute('src')?.includes('red_cross')){
      const text=panel.querySelector('#ErrMsg')?.textContent||'';
      const unavailable=/VIES|service|busy|unavailable|timeout/i.test(text);
      fail(unavailable?panel.dataset.unavailable:panel.dataset.invalid,null,unavailable?'unavailable':'invalid');
    }
    schedule();
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','src']});
  window.addEventListener('pageshow',()=>{finishPending();schedule();});
  sync();
})();


  } catch(e) { console.error(e); }
})();
})();
